/** START SCROLL HEADER COLOR-CHANGING */
window.addEventListener('scroll', function () {
    const header = document.getElementById('main-header')
    const scrollPosition = window.scrollY

    if (scrollPosition > 0) {
        header.classList.add('header-scrolled')
    } else {
        header.classList.remove('header-scrolled')
    }
})
/** END SCROLL HEADER COLOR-CHANGING */

window.addEventListener('DOMContentLoaded', (event) => {
    /** START DROPDOWN MENU FOR */
    if (window.matchMedia('(min-width: 1025px)').matches) {
        const itemsMenu = $('.header-item-menu')

        itemsMenu.on('mouseenter', function (e) {
            if ($(e.currentTarget).hasClass('menu-item-has-children')) {
                $(this).addClass('is-active')
            }
        })

        itemsMenu.on('mouseleave', function (e) {
            itemsMenu.removeClass('is-active')
        })
    }

    if (window.matchMedia('(max-width: 1024px)').matches) {
        $('.burger').on('click', function (e) {
            $(e.target).toggleClass('is-opened')
            $('body').toggleClass('burger-is-opened')
            $('.navbar.navbar-expand-lg').toggleClass('nav-is-opened')
        })

        $('.secondary-menu-container').each(function () {
            const parentMenuItem = $(this).closest('.menu-item-has-children')
            const secondaryMenuName = $(parentMenuItem).find('a > span').text()
            console.log(secondaryMenuName)

            $(this).prepend(`<li class="nav__item"><a class="navigation-menu__nav-link sub__close">${secondaryMenuName}</a></li>`)
        })

        $('.submenu-level-1').each(function () {
            const parentMenuItem = $(this).closest('.menu-item-has-children')
            const secondaryMenuName = $(parentMenuItem).find('.submenu-item').text()

            $(this).prepend(`<li class="nav__item"><a class="navigation-menu__nav-link sub__close">${secondaryMenuName}</a></li>`)
        })

        $('.submenu-level-2').each(function () {
            const parentMenuItem = $(this).closest('.menu-item-has-children')
            const secondaryMenuName = $(parentMenuItem).find('.submenu-item-2').text()

            $(this).prepend(`<li class="nav__item"><a class="navigation-menu__nav-link sub__close">${secondaryMenuName}</a></li>`)

        })

        $('.sub__close').click(function (e) {
            e.preventDefault();

            $(this).parent().parent().removeClass('is-active');
        });

        $('.navigation-menu__nav-link, .submenu-item, .submenu-item-1').click(function (e) {
            if ($(this).closest('.navigation-menu__item').hasClass('menu-item-has-children')) {
                e.preventDefault()

                $(this).siblings().addClass('is-active');
            }
        });
    }
    /** END DROPDOWN MENU FOR */
    /** START DROPDOWN MENU FOOTER */
    if (window.matchMedia('(min-width: 769px)').matches) {
        $('.footer-box-list-address').on('click', function (event) {
            const currentTarget = $(event.currentTarget);
            const parentWrapper = currentTarget.parent();

            $('.footer-contacts-wrapper').not(parentWrapper).removeClass('is-active');
            parentWrapper.toggleClass('is-active');
        });
    }
    if (window.matchMedia('(min-width: 375px) and (max-width: 490px)').matches) {
        $('.footer-box-list-title').on('click', function (event) {
            const $this = $(this);
            const parentCol = $this.closest('.footer-box-list-col');
            const wrapper = parentCol.find('.footer-contacts-wrapper');

            // Переключаем классы только для текущего столбца и его обёртки
            parentCol.toggleClass('is-active');
            wrapper.toggleClass('is-active');
        });
    }

    if (window.matchMedia('(max-width: 768px)').matches) {
        $('.footer-box-list-address').on('click', function (event) {
            const currentTarget = $(event.currentTarget);
            const parentWrapper = currentTarget.parent();

            $('.footer-contacts-wrapper').not(parentWrapper).removeClass('is-active');
            parentWrapper.toggleClass('is-active');
        });
    }
    /** END DROPDOWN MENU FOOTER */

})
/** start Form JS **/
